import {
  CREDIT_NOTE_DELETE_ACTION_TYPE,
  CREDIT_NOTE_DETAILS_ACTION_TYPE,
  CREDIT_NOTE_DETAILS_ORDER_ACTION_TYPE,
  CREDIT_NOTE_DOWNLOAD_ACTION_TYPE,
  CREDIT_NOTE_IE_ACTION_TYPE,
  CREDIT_NOTE_LIST_ACTION_TYPE,
} from "../../utils/constants";

const initialState = [];

function accountCreditNoteReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREDIT_NOTE_LIST_ACTION_TYPE:
      return [...state, payload];
    case CREDIT_NOTE_DETAILS_ORDER_ACTION_TYPE:
      return [...state, payload];
    case CREDIT_NOTE_DETAILS_ACTION_TYPE:
      return [...state, payload];
    case CREDIT_NOTE_IE_ACTION_TYPE:
      return [...state, payload];
    case CREDIT_NOTE_DELETE_ACTION_TYPE:
      return [...state, payload];
      case CREDIT_NOTE_DOWNLOAD_ACTION_TYPE:
        return [...state,payload];
    default:
      return state;
  }
}

export default accountCreditNoteReducer;
